export default function Wordmark({ markClassName = 'h-10', textClassName = 'text-2xl' }) {
  return (
    <span className="inline-flex shrink-0 items-center gap-2.5 whitespace-nowrap">
      <img
        src="/rebuild/brand/seascope-mark.png"
        alt=""
        className={`${markClassName} w-auto`}
        width="40"
        height="40"
      />
      <span className={`font-display font-medium leading-none ${textClassName}`}>
        <span className="text-ink">SeaScope</span>{' '}
        <span className="text-teal-strong">CDS</span>
      </span>
    </span>
  );
}
